/**
 * StudentShopScreen — la « Boutique de gestes » de l'élève (routes `shop` et `petals`), à la place
 * de `student/shop/MyPetalsTabScreen.js` quand l'espace élève est allumé.
 *
 * Patron A : les produits et le compte sont dans le store (`studentShopViewModel`), la flèche relit
 * le compte (`useStudentShopData`), la feuille d'un geste, l'achat et l'accusé vivent dans
 * `useStudentShopState`.
 */
import React from "react"
import { useSelector } from "react-redux"

import { StudentShopPage } from "../../../../../../design-system/student"
import { studentShopViewModel } from "../../../../view-models/student/Game/studentShopViewModel"
import { useStudentShopData } from "./useStudentGameData"
import { useStudentShopState } from "./useStudentShopState"

export function StudentShopScreen() {
    useStudentShopData()
    const { ui, sheet, ...state } = useStudentShopState()
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const vm = useSelector((reduxState: any) =>
        studentShopViewModel(reduxState, ui.gesture?.id ?? null, ui.gesturesSkillSet, ui.step === "purchased")
    )

    return (
        <StudentShopPage
            petals={vm.petals}
            items={vm.items}
            hint={vm.hint}
            loading={vm.loading}
            {...state}
            sheet={{
                ...sheet,
                gesture: vm.sheetGesture,
                purchasedCount: vm.sheetPurchasedCount,
                purchasing: vm.purchasing,
                outcome: vm.outcome,
                choosingNewTitle: vm.choosingNewTitle,
            }}
        />
    )
}
